import { useEffect } from 'react';
import { useGlobalTimer } from '@utils/TimerContext';

type TimerCallback = () => void | Promise<void>;

export function useEveryNSeconds(callback: TimerCallback, everySeconds = 300): void {
	const { registerAction } = useGlobalTimer();

	useEffect(() => {
		const unregister = registerAction(callback, everySeconds);
		return unregister;
	}, [callback, everySeconds, registerAction]);
}
